/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Status } from '../models/Campaignservicev1Status';
import { HttpFile } from '../http/http';

/**
* CampaignUnarchived is an event that is produced by the campaign service, after the campaign has been successfully un archived.
*/
export class V1CampaignUnarchived {
    'id'?: string;
    'requestId'?: string;
    'userId'?: string;
    'orgId'?: string;
    'timestamp'?: Date;
    'status'?: Campaignservicev1Status;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "Campaignservicev1Status",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CampaignUnarchived.attributeTypeMap;
    }

    public constructor() {
    }
}

